import page from './vendor/page';
import {$, konsole, _u, _ga, fastdom, rx} from './util';
import _PHP from './_PHP';

const layout = (function() {
  const $dom = {
    win: $(window),
    doc: $(document),
    body: $(document.body),
    w_head: $("#w_head"),
    pages: $("#minimost-begin > article"),
    menus: $("#main-menu > a")
  };
  const _pub = {};
  const el_scrollable = document.scrollingElement;
  const el_usedbg = $("#sec_search > .used-bg")[0];
  let pageClass = null;
  let compactMenu = false;

  if (_u.isTouchDevice()) {
    $("html").addClass("istouchdevice");
  }


  if (window.top === window.self) {
    $("html").addClass("viewin_direct_page");
  }

  function updateLayout() {
    const scrollTop = $dom.win.scrollTop();
    let bg_fix = null;
    let set_menu = null;
    if (
      document.body.classList &&
      el_scrollable &&
      _PHP.menumode === "normal" &&
      !_PHP.mixedmode &&
      _PHP.usedCarsEnabled &&
      // eslint-disable-next-line no-use-before-define
      router.curPageIdIs('search')
    ) {
      if (el_scrollable.scrollTop > el_usedbg.offsetTop) {
        if (!document.body.classList.contains("bgfix")) {
          bg_fix = 'add';
        }
        set_menu = 'used';
      }
      else {
        if (document.body.classList.contains("bgfix")) {
          bg_fix = 'remove';
        }
        set_menu = 'new';
      }
    }
    else if (document.body.classList.contains("bgfix")) {
      bg_fix = 'remove';
    }

    fastdom.mutate(function() {
      if (bg_fix === 'add') {
        document.body.classList.add("bgfix");
      }
      else if (bg_fix === 'remove') {
        document.body.classList.remove("bgfix");
      }

      // eslint-disable-next-line no-use-before-define
      if (set_menu) { router.setMenu(set_menu); }

      if (scrollTop > 1) {
        _pub.compactMenu(true);
      }
      else {
        _pub.compactMenu(false);
      }
    });
  }


  _pub.init = function() {
    $dom.win.scroll(fastdom.measure(updateLayout));
  };

  _pub.updateLayout = function() {
    updateLayout();
  };
  _pub.enableAnim = function() {
    document.body.classList.add("anim-on");
  };

  _pub.compactMenu = function(onOff) {
    if (onOff) {
      if (!compactMenu) {
        $dom.w_head.addClass("compact");
        compactMenu = true;
      }
    }
    else {
      if (compactMenu) {
        $dom.w_head.removeClass("compact");
        compactMenu = false;
      }
    }
  };

  _pub.setPage = function(pageId) {
    _pub.setPageClass(pageId);
    $dom.pages
      .filter('#sec_' + pageId)
      .show()
      .siblings()
      .hide();
  };

  _pub.setMenu = function(menuId) {
    if (menuId) {
      $dom.menus
        .filter('[data-page="' + (menuId || '') + '"]')
        .addClass("active")
        .siblings()
        .removeClass("active")
      ;
    }
    else {
      $dom.menus.filter('.active').removeClass("active");
    }
  };

  _pub.setPageClass = function(className) {
    if (pageClass) {
      if (className === pageClass) {
        return;
      }
      document.documentElement.classList.remove('page-' + pageClass);
    }
    document.documentElement.classList.add('page-' + className);
    pageClass = className;
  };


  return _pub;
})();

const router = (function() {
  const defaultTitle = document.title;
  const paths = {
    '/':
    // (
    // _PHP.salemode ? {
    //     title: 'Azonnal elérhető készlet',
    //     menuId: 'sale',
    //     pageId: 'sale',
    //     // scrollAnchor: '#minimost-wrp'
    //   } : {
    //     title: 'Azonnal elérhető készlet',
    //     menuId: 'stock',
    //     pageId: 'search',
    //     // scrollAnchor: '#minimost-wrp'
    //   }
    // ),
    {
      title: 'Azonnal elérhető készlet',
      menuId: 'stock',
      pageId: 'search'
    },
    '/stock/': {
      title: 'MINI készlet',
      menuId: 'stock',
      pageId: 'search',
      scrollAnchor: '#minimost-wrp'
    },
    '/new/': {
      title: 'Új MINI-k',
      menuId: 'new',
      pageId: 'search',
      scrollAnchor: '#minimost-wrp'
    },
    '/used/': {
      title: 'Használt MINI-k',
      menuId: 'used',
      pageId: 'search',
      scrollAnchor: '#result-hero-used'
    },
    '/sale/': (_PHP.salemode ? {
      title: 'Akciós MINI-k',
      menuId: 'sale',
      pageId: 'sale',
      scrollAnchor: '#minimost-wrp'
    } : {
      title: 'Új MINI-k',
      menuId: 'new',
      pageId: 'search',
      scrollAnchor: '#minimost-wrp'
    }),
    '/sale/:carid': (
      _PHP.salemode ? {
        title: '{{id}} {{name}} megtekintése',
        menuId: 'sale',
        type: 'list',
        id: 'sale',
        pageId: 'sale'
      } : { // ha a sale mode nincs bekapcsolva mégis van sale/:carid akkor new/:carid
        title: '{{id}} {{name}} megtekintése',
        menuId: 'new',
        type: 'list',
        id: null, // mindenhol keres
        pageId: 'search'
      }
    ),
    '/stock/:carid': {
      title: '{{id}} {{name}} megtekintése',
      findWhere: true,
      type: 'list',
      menuId: 'new',
      id: null, // mindenhol keres
      pageId: 'search'
    },
    '/new/:carid': {
      title: '{{id}} új {{name}} megtekintése',
      menuId: 'new',
      type: 'list',
      id: 'new',
      pageId: 'search'
    },
    '/used/:carid': {
      title: '{{id}} használt {{name}} megtekintése',
      menuId: 'used',
      id: 'used',
      pageId: 'search'
    },
    '/contact/': {
      title: 'Kapcsolat',
      menuId: 'contact',
      pageId: 'contact',
      scrollAnchor: '#sec_contact'
    },
    '/cookies/': {
      title: 'Cookie-k',
      menuId: '',
      pageId: 'cookies',
      onShow() {
        window.ePaasExt.initCookiePage();
      },
      onHide() {
        window.ePaasExt.emptyCookiePage();
      },
      scrollAnchor: '#sec_cookies'
    },
    '/info/': {
      title: 'Információk',
      menuId: 'info',
      pageId: 'info',
      scrollAnchor: '#sec_info'
    },
    '/notfound/': {
      title: 'oldal nem található (404)',
      menuId: '',
      pageId: 'notfound',
      scrollAnchor: '#sec_notfound'
    }
  };

  const pathsArr = Object.entries(paths).map(a => ({...a[1], path: a[0]}));

  let once = true;
  let getResultItem = function() { throw new Error('getResultItem is not set by .init'); };
  let curPath = null;
  let activeMenuId = null;
  let activePageId = null;
  let curCtx = {};
  let curRoute = {};
  const pub = {};
  const changeFns = [];
  const history = []; // setPathPort history
  const routerHistory = []; // page.js history

  function cleanPath(path) {
    if (typeof path === "string") {
      return path.replace(/^\/|\/$/g, '');
    }
    else if (path !== null) {
      konsole.log('Invalid path', path);
    }
  }

  function getParams(extraParams, withHash) {
    const wl = window.location;
    // todo extend with extra params
    return wl.search + (withHash ? wl.hash : '');
  }

  function _pathChange(path, pageCtx, pathSetup, fn) {
    const route = paths[path] || {};

    let scrollAnchor = null;
    let resultItem = null;
    const prevRoute = pub.getLastRouterHistory();

    if (
      route && !pageCtx.params.carid &&
      prevRoute.pathSetup && prevRoute.pathSetup.type !== 'list'
    ) {
      scrollAnchor = route.scrollAnchor || scrollAnchor;
    }




    // konsole.log('PATH CHANGE: ', {
    //   newPath: path,
    //   newCtx: pageCtx,
    //   oldPath: curPath,
    //   pldCtx: curCtx
    // });

    switch (path) {
      case '/sale/:carid':
      case '/stock/:carid':
      case '/new/:carid':
      case '/used/:carid': {
        // scrollAnchor = '#' + pageCtx.params.carid;
        break;
      }
    }

    switch (path) {
      case 'notfound': {
        pub.setPathPort('/notfound/');
        break;
      }

      case '/new/':
      case '/used/':
      case '/stock/:carid':
      case '/new/:carid':
      case '/used/:carid': {
        if (_PHP.menumode === "separate") {
          const isUsed = path.indexOf('/used/') > -1;
          $("#result-page-new").toggle(!isUsed);
          $("#result-page-used").toggle(isUsed);
          if (!_PHP.mixedmode) {
            $("body").toggleClass("bgfix", isUsed);
          }
        }
        break;
      }
    }

    let pageTitleSuffix = route.title;

    pub.setPage(route.pageId);
    pub.setMenu(route.menuId);

    if (pageCtx.params.carid) {
      resultItem = getResultItem(pageCtx.params.carid, pathSetup ? (pathSetup.id || null) : null);
    }

    if (resultItem && resultItem.showDetails) {
      // _u.scrollTo(2, 0);
      // layout.compactMenu(false);
      resultItem.showDetails({
        setRoute: once,
        scrollAnim: !once
      });

      pageTitleSuffix = pageTitleSuffix
        .replace('{{id}}', resultItem.data._id)
        .replace('{{name}}', resultItem.data.name.replace('| ', ''))
      ;
    }
    else {
      pub.trigger('nocarid');
      if (once && scrollAnchor === null) {
        // első betöltéskor ha létezik ilyen tartalom
        // egyébb tartalom esetén scroll top
        _u.scrollTo(0, 0);
      }
    }

    if (scrollAnchor) {
      _u.scrollTo(2, 0);
      layout.compactMenu(false);
      _u.scrollTo($(scrollAnchor), 0, null, 0);
    }

    once = false;

    if (typeof fn === "function") {
      fn(pageCtx, path, curCtx, curPath, pathSetup);
    }
    curCtx = $.extend({}, pageCtx); // order before trigger
    curPath = path;
    curRoute = route;
    document.title = defaultTitle + ' - ' + pageTitleSuffix;
    pub.trigger('pathChange', {
      path: path,
      pageCtx: pageCtx
    });

    setTimeout(function() {
      fastdom.mutate(function() {
        layout.enableAnim();
      });
    }, 100);

    pub.addRouterHistory(
      {path, pageCtx, pathSetup, fn}
    );
  }

  pub.init = function(setup) {
    const validPaths = [];
    if (setup && setup.getResultItem) {
      getResultItem = setup.getResultItem;
    }


    for (const path in paths) {
      if (Object.prototype.hasOwnProperty.call(paths, path)) {
        validPaths.push(cleanPath(path));
        pub.addRoute(path, paths[path]);
      }
    }

    page('*', function(pageCtx) { return _pathChange('notfound', pageCtx, paths['/notfound/'], null); });

    page.start({
      window: window,
      dispatch: true,
      click: false,
      popstate: true,
      hashbang: false,
      decodeURLComponents: true
    });


    $(document).on('click touch', 'a:not(.jslink)', function(e) {
      const href = this.getAttribute('href');
      const hrefClean = cleanPath(href);
      if (href && href.charAt(0) === '/' && href.search(rx.is_asset) === -1) {
        if (validPaths.indexOf(hrefClean) > -1) {
          e.preventDefault();
          pub.setPathPort({path: href, silent: false, byUser: true});
        }
        else {
          konsole.error('Invalid path: ' + href);
        }
        // return;
      }
    });
  };


  pub.getLastRouterHistory = function() {
    return routerHistory.slice(-1)[0] || {};
  };
  pub.addRouterHistory = function({path, pageCtx, pathSetup, fn}) {
    routerHistory.push({path, pageCtx, pathSetup, fn});
    if (routerHistory.length > 10) {
      routerHistory.shift();
    }
  };

  pub.curPageIdIs = function(id) {
    return curRoute.pageId === id;
  };

  pub.setPage = function(pageId) {
    if (activePageId === pageId) {
      return;
    }
    const currRoute = pathsArr.find((p) => p.pageId === activePageId);
    const nextRoute = pathsArr.find((p) => p.pageId === pageId);
    if (currRoute && typeof currRoute.onHide === "function") {
      currRoute.onHide();
    }
    if (nextRoute && typeof nextRoute.onShow === "function") {
      nextRoute.onShow();
    }
    activePageId = pageId;
    layout.setPage(pageId);
  };

  pub.setMenu = function(menuId) {
    if (activeMenuId === menuId) {
      return;
    }
    activeMenuId = menuId;
    layout.setMenu(menuId);
  };

  pub.trigger = function(eventType, data = {}) {
    const eventData = {
      history,
      ...data
    };
    for (let i = 0; i < changeFns.length; i++) {
      const [eType, fn] = changeFns[i];
      if (typeof fn === "function" && eventType === eType) {
        fn(curCtx, eventData);
      }
    }
  };

  pub.onChange = function(fn) {
    pub.on('pathChange', fn);
  };

  pub.on = function(eventType, fn) {
    changeFns.push([eventType, fn]);
  };

  pub.getParentPath = function name(path, depth = 1) {
    const segments = path.split('/');
    do { segments.pop(); } while (--depth > 0);
    const r = '/' + segments.join('/').replace(/\/$/, '').replace(/^\/+/, '');
    return r;
  };

  pub.unsetPathPort = function({path, silent = true, byUser, depth = 1}) {
    pub.setPathPort({
      path: pub.getParentPath(path, depth),
      silent,
      byUser
    });
  };

  pub.setPathPort = function({path, silent, byUser, params, hash}) {
    if (arguments[0] === "/notfound/") {
      path = "/notfound/";
    }
    if (path.charAt(0) !== '/') { path = '/' + path; }
    // console.log('SET PAGE ROUTE', {
    //   path: path,
    //   silent: silent
    // });
    hash = (hash || '').replace('#', '');
    const fullpath = path + getParams(params) + (hash ? `#${hash}` : '');

    const whistory = window.history || {};

    if (silent) {
      // if (whistory.replaceState) { whistory.replaceState(null, null, fullpath); }
      if (whistory.pushState) { whistory.pushState(null, null, fullpath); }
      history.push({ path, fullpath, silent: true, params, byUser});

      return; // no page change
    }
    history.push({ path, fullpath, silent: false, params: byUser });
    page.show(fullpath);

    _ga('send', {
      hitType: 'pageview',
      page: path
    });
  };

  pub.addRoute = function(path, pathSetup, fn) {
    page(path, function(pageCtx) { return _pathChange(path, pageCtx, pathSetup, fn); });
  };

  pub.getParams = function() {
    return getParams();
  };

  pub.onChange(function onPageChange() {
    $(window).trigger("resize");
  });

  return pub;
})();


export default router;
export { router, layout };
